module.exports = __webpack_public_path__ + "static/media/procedureNew.78e98f43.svg";